interface RailItem {
  id: string;
  label: string;
  color: string;
}

interface Props {
  /** The sections this person may open, in the order the layout gives them. */
  rails: readonly RailItem[];
  active: string;
  onChange: (id: string) => void;
}

export function SideRail({ rails, active, onChange }: Props) {
  return (
    <aside className="siderail" aria-label="Sections">
      {rails.map((rail) => (
        <button
          key={rail.id}
          type="button"
          className={rail.id === active ? 'rail-item is-active' : 'rail-item'}
          aria-pressed={rail.id === active}
          onClick={() => onChange(rail.id)}
        >
          <span className="rail-label">{rail.label}</span>
          <span className="rail-dot" style={{ background: rail.color }} />
        </button>
      ))}
    </aside>
  );
}
